import React, { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { resolveMediaUrl } from "@/lib/mediaUrl";
import { fetchLinkPreview, getCachedLinkPreview } from "@/lib/linkPreviewCache";

// ── WhatsApp-style rich link preview cards ──
// Lot 678 — le cache (mémoire + appareil 24 h, 2 requêtes max en parallèle) vit dans lib/linkPreviewCache.js,
// partagé avec le fil et les commentaires (LinkCard). Ré-exporté ici pour les imports existants.
export { fetchLinkPreview };

export const ChatLinkPreview = ({ url, mine, selectMode, testId }) => {
  const [pv, setPv] = useState(() => getCachedLinkPreview(url) || null);
  useEffect(() => {
    let alive = true;
    const hit = getCachedLinkPreview(url);
    if (hit !== undefined) { setPv(hit); return undefined; } // connu (avec ou sans aperçu) : aucune requête
    fetchLinkPreview(url).then((d) => { if (alive) setPv(d); });
    return () => { alive = false; };
  }, [url]);
  if (!pv || (!pv.title && !pv.thumbnail)) return null;
  const domain = pv.kind === "article" ? (pv.domain || "") : pv.provider === "youtube" ? "youtube.com" : pv.provider === "facebook" ? "facebook.com" : (pv.domain || "");
  const isVideo = pv.kind !== "article";
  const open = (e) => { if (selectMode) return; e.stopPropagation(); window.open(url, "_blank", "noopener,noreferrer"); };
  return (
    <button
      onClick={open}
      onPointerDown={selectMode ? undefined : (e) => e.stopPropagation()}
      className="block w-[248px] max-w-full text-left mb-1.5 rounded-lg overflow-hidden border"
      style={{ borderColor: mine ? "rgba(0,0,0,0.10)" : "var(--yalola-border)", background: mine ? "rgba(255,255,255,0.6)" : "white" }}
      data-testid={testId}
    >
      {pv.thumbnail ? (
        <div className="relative">
          <img src={resolveMediaUrl(pv.thumbnail)} alt="" className="w-full aspect-video object-cover" />
          {isVideo && (
            <span className="absolute inset-0 grid place-items-center pointer-events-none">
              <span className="h-11 w-11 rounded-full bg-black/55 grid place-items-center"><Play size={20} className="text-white ml-0.5" fill="currentColor" /></span>
            </span>
          )}
        </div>
      ) : null}
      <div className="px-2.5 py-1.5">
        {domain && <div className="text-[10px] font-semibold uppercase tracking-wide truncate" style={{ color: "var(--yalola-text-muted)" }}>{domain}</div>}
        <div className="text-[13px] font-semibold leading-snug line-clamp-2" style={{ color: "var(--yalola-text)" }} data-testid={testId ? `${testId}-title` : undefined}>{pv.title || url}</div>
        {pv.description && <div className="text-[11px] leading-snug line-clamp-2 mt-0.5" style={{ color: "var(--yalola-text-muted)" }}>{pv.description}</div>}
      </div>
    </button>
  );
};
